import { memo, type FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
// Skillmore UI Components
import ContentCard from '@empathco/ui-components/src/elements/ContentCard';
// local imports
import { hasHRBP } from '../models/user';
import useCustomerSettings from '../config/customer';
import { PATH_HR, PATH_SUPERVISOR_TEAM } from '../config/paths';
import useVerifyUser from '../hooks/useVerifyUser';
import Screen from '../v3/Screen';
import ManagerDashboard from '../components/ManagerDashboard';
import DashboardAnalytics from '../components/DashboardAnalytics';

const SupervisorScreen: FunctionComponent = () => {
  const { DA_TABS, HAS_MANAGER_DASHBOARD, HAS_MANAGER_DASHBOARD_ANALYTICS } = useCustomerSettings();
  const { content, user } = useVerifyUser({ manager: true });
  const supervisorDaTabs = HAS_MANAGER_DASHBOARD_ANALYTICS ? DA_TABS : null;
  if (content) return content;

  if (hasHRBP(user)) return <Navigate replace to={PATH_HR}/>;
  if (!supervisorDaTabs && !HAS_MANAGER_DASHBOARD) return <Navigate replace to={PATH_SUPERVISOR_TEAM}/>;

  return (
    <Screen withSettings>
      <ContentCard>
        {supervisorDaTabs ? <DashboardAnalytics supervisor/> : <ManagerDashboard/>}
      </ContentCard>
    </Screen>
  );
};

export default memo(SupervisorScreen);
